module.exports = {
  vantageContent() {
    return [
      "./node_modules/vantage-ui/src/lib-components/**/*.vue",
      "./node_modules/vantage-ui/src/lib-components/**/*.js"
    ];
  }
};
